"use strict";module.exports={"currentLocale":"en","isTestActive":function(e){return"ifit"===e||!(!process.browser||"ifit"!==window._d.lang)}};